/**
 * @fileoverview gRPC-Web generated client stub for accountpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')

const proto = {};
proto.accountpb = require('./accountcontact_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.AccountContactServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.AccountContactServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ListAccountContactRequest,
 *   !proto.accountpb.ListAccountContactResponse>}
 */
const methodDescriptor_AccountContactService_ListAccountContact = new grpc.web.MethodDescriptor(
  '/accountpb.AccountContactService/ListAccountContact',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ListAccountContactRequest,
  proto.accountpb.ListAccountContactResponse,
  /**
   * @param {!proto.accountpb.ListAccountContactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListAccountContactResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.ListAccountContactRequest,
 *   !proto.accountpb.ListAccountContactResponse>}
 */
const methodInfo_AccountContactService_ListAccountContact = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.ListAccountContactResponse,
  /**
   * @param {!proto.accountpb.ListAccountContactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListAccountContactResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ListAccountContactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.ListAccountContactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ListAccountContactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.AccountContactServiceClient.prototype.listAccountContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.AccountContactService/ListAccountContact',
      request,
      metadata || {},
      methodDescriptor_AccountContactService_ListAccountContact,
      callback);
};


/**
 * @param {!proto.accountpb.ListAccountContactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ListAccountContactResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.AccountContactServicePromiseClient.prototype.listAccountContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.AccountContactService/ListAccountContact',
      request,
      metadata || {},
      methodDescriptor_AccountContactService_ListAccountContact);
};


module.exports = proto.accountpb;

